import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import { AuthenticateSurvey } from './auth.model';
import { FeatureFlipperService } from './feature-flipper.service';
import { SurveyAuthService } from './survey-auth.service';

@Injectable()
export class AuthService {
  constructor(
    private store: Store,
    private http: HttpClient,
    private router: Router,
    private surveyAuthService: SurveyAuthService,
    private featureFlipper: FeatureFlipperService
  ) {
    // this.isLoggedIn = true;
    // if (token !== null) {
    // Possible refactor: Load user in here and remove user service at all
    // A valid user => this.isLoggedIn = true
    // this.authUser(token).subscribe(() => {
    //   this.isLoggedIn = true;
    // }, (error) => {
    //   this.logOut();
    // })
    // }
  }

  // Auth function for possible refactor explained above
  // authUser(token) {
  //   let headers = new Headers({
  //     'Authorization': 'Bearer ' + token,
  //     'X-Key-Inflection' : 'camel'
  //   });

  //   return this.http
  //     .get(environment.apiHost + '/api/v1/whoami', new RequestOptions({ headers: headers }))
  //     .map((res: Response) => {
  //       let response = res.json();
  //       return response;
  //     })
  //     .catch((error: any) => {
  //       return Observable.throw(error);
  //     })
  // }

  logIn(email: string, password: string) {
    return this.http
      .post(environment.apiHost + '/user_token', {
        auth: { email, password }
      })
      .map(this.extractToken, this)
      .catch(this.handleError);
  }

  seamlessLogin(email: string, token: string) {
    return this.http
      .post(environment.apiHost + '/user_token/seamless', {
        auth: { email: email, seamless_login_token: token }
      })
      .map(this.extractToken, this)
      .catch(this.handleError);
  }

  logOut() {
    localStorage.removeItem('auth.token');
  }

  private extractToken(res: any) {
    const token = res.jwt;
    if (this.featureFlipper.enabled('survey_analytics_nextgen'))
      this.store.dispatch(new AuthenticateSurvey(token));
    return token;
  }

  private handleError(error: any) {
    const errMsg = error.message
      ? error.message
      : error.status
      ? `${error.status} - ${error.statusText}`
      : 'Server error';
    console.error(errMsg); // log to console
    return Observable.throw(error);
  }

  token() {
    return JSON.parse(localStorage.getItem('auth.token'));
  }
}
